import Vue from 'vue';
import VueI18n from 'vue-i18n';
import en from '../lang/en.json';
import es from '../lang/es.json';
import pt from '../lang/pt-br.json';

Vue.use(VueI18n);

export const i18n = new VueI18n({
  language: 'pt-br',
  fallbackLocale: 'pt-br',
  silentFallbackWarn: true,
  messages: {
    en: en,
    'pt-br': pt,
    es: es
  }
});
